import { Entity, ThemeExposure } from '@toggle/toggle';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';

import { StepperSection } from '../components/stepper-section/StepperSection';
import { CompetitorsSection } from './components/competitors-section/CompetitorsSection';
import { RankSection } from './components/rank-section/RankSection';
import { SourceEvidenceSection } from './components/source-evidence-section/SourceEvidenceSection';
import * as S from './ThemeExposureTab.styles';

interface ThemeExposureTabProps {
  entity: Entity;
  theme: ThemeExposure;
}

export const ThemeExposureTab = ({ entity, theme }: ThemeExposureTabProps) => {
  const { t } = useTranslation(['widget']);

  const { rank, description } = theme.relationship;

  const getComponentWithErrorBoundary = (child: ReactNode) => (
    <ErrorBoundaryWrapper>{child}</ErrorBoundaryWrapper>
  );

  return (
    <S.Root>
      <StepperSection
        entity={entity}
        theme={theme}
        title={t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.assetThemeExposure',
          {
            name: entity.name,
          }
        )}
        activeIndex={0}
        description={description}
      />
      <RankSection
        title={t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.rank'
        )}
        label={t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.current'
        )}
        rank={rank}
      />
      {getComponentWithErrorBoundary(
        <SourceEvidenceSection themeData={theme} />
      )}
      <S.HorizontalDivider />
      {getComponentWithErrorBoundary(
        <CompetitorsSection
          entityTag={entity.tag}
          themeId={theme.theme.id}
          themeName={theme.theme.name}
        />
      )}
    </S.Root>
  );
};
